import { DA_COMM_EMOTE, DA_OFF_EMOTE } from './types';
import { OfficialEmoteViewer, CommunityEmoteViewer } from './viewer/ReactViewer';
export const typeMapper = ()=>({
        [DA_OFF_EMOTE]: {
            component: OfficialEmoteViewer,
            elementType: 'inline'
        },
        [DA_COMM_EMOTE]: {
            component: CommunityEmoteViewer,
            elementType: 'inline'
        }
    });
